/**
 * StepperPlusIcon Component
 *
 * Plus icon for stepper increment buttons.
 * Based on Figma design: 12x12 cross.
 */

export function StepperPlusIcon({ className }: { className?: string }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path d="M0 6H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M6 0V12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
